import config from "@/config/config";

import Index from "@/pages/product-category/index.vue";
import List from "@/pages/product-category/list/list.vue";
import View from "@/pages/product-category/view/view.vue";
import New from "@/pages/product-category/new/new.vue";
import Edit from "@/pages/product-category/edit/edit.vue";

const modulePermission = config.modules.productCategory;

export default {
  path: "/product-category",
  name: "product-category",
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: "enabled_read",
  },
  children: [
    {
      path: "list",
      name: "product-category-list",
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
    },
    {
      path: ":id",
      name: "product-category-view",
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
      props: true,
    },
    {
      path: "new",
      name: "product-category-new",
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_create",
      },
    },
    {
      path: ":id/e",
      name: "product-category-edit",
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_edit",
      },
      props: true,
    },
  ],
};
